/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedHeadTitleTag_metadata = {
    readonly title: string | null;
    readonly " $refType": "SharedHeadTitleTag_metadata";
};
export type SharedHeadTitleTag_metadata$data = SharedHeadTitleTag_metadata;
export type SharedHeadTitleTag_metadata$key = {
    readonly " $data"?: SharedHeadTitleTag_metadata$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedHeadTitleTag_metadata">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedHeadTitleTag_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "MetaData",
  "abstractKey": null
};
(node as any).hash = 'ecdf49ebde8460cdcb8f117d80dc9a0e';
export default node;
